module.exports = __webpack_public_path__ + "img/pdf.d7e82936.svg";